import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.207 6.95711C12.5975 6.56658 12.5975 5.93342 12.207 5.54289C11.8165 5.15237 11.1833 5.15237 10.7928 5.54289L7.99994 8.33573L5.20711 5.54289C4.81658 5.15237 4.18342 5.15237 3.79289 5.54289C3.40237 5.93342 3.40237 6.56658 3.79289 6.95711L7.29283 10.457C7.68336 10.8476 8.31652 10.8476 8.70705 10.457L12.207 6.95711Z"
        fill="#101010"
      />
    </svg>
  );
};

export default Svg;
